/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Illegal_Transaction_TitleInputs */

const en_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Issue`)
};

const ar_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشكلة الطلب`)
};

const de_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellproblem`)
};

const es_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emisión del pedido`)
};

const fr_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème lors de la commande`)
};

const it_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emissione dell'ordine`)
};

const ja_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文エラーが発生しました`)
};

const ko_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 오류`)
};

const pt_br_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema com o pedido`)
};

const ru_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У заказа возникла ошибка`)
};

const th_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัญหาคำสั่งซื้อ`)
};

const tr_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş Sorunu`)
};

const zh_cn_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单异常`)
};

const zh_tw_dialog_illegal_transaction_title = /** @type {(inputs: Dialog_Illegal_Transaction_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂單異常`)
};

/**
* | output |
* | --- |
* | "Order Issue" |
*
* @param {Dialog_Illegal_Transaction_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_illegal_transaction_title = /** @type {((inputs?: Dialog_Illegal_Transaction_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Illegal_Transaction_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_illegal_transaction_title(inputs)
	if (locale === "ar") return ar_dialog_illegal_transaction_title(inputs)
	if (locale === "de") return de_dialog_illegal_transaction_title(inputs)
	if (locale === "es") return es_dialog_illegal_transaction_title(inputs)
	if (locale === "fr") return fr_dialog_illegal_transaction_title(inputs)
	if (locale === "it") return it_dialog_illegal_transaction_title(inputs)
	if (locale === "ja") return ja_dialog_illegal_transaction_title(inputs)
	if (locale === "ko") return ko_dialog_illegal_transaction_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_illegal_transaction_title(inputs)
	if (locale === "ru") return ru_dialog_illegal_transaction_title(inputs)
	if (locale === "th") return th_dialog_illegal_transaction_title(inputs)
	if (locale === "tr") return tr_dialog_illegal_transaction_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_illegal_transaction_title(inputs)
	return zh_tw_dialog_illegal_transaction_title(inputs)
});